export default "//yastatic.net/s3/distribution/pythia/frontend/_/49e55f49f68cd4ae2142bdf8b875cb78.svg";